module.exports = __webpack_public_path__ + "img/background12.a708f989.jpg";